import { createSlice } from '@reduxjs/toolkit'
import { CONFIG } from 'src/config'
import * as actionType from 'src/lib/actions'

const initialState = {
  ...CONFIG,
}

export const themeSlice = createSlice({
  name: 'theme',
  initialState,

  reducers: {
    changeConfig: (state, action) => {
      let { type, menu, layout } = action.payload
      let open = []
      let trigger = []
      switch (type) {
        case actionType.CHANGE_LAYOUT:
          state.layout = layout
          break
        case actionType.COLLAPSE_MENU:
          state.collapseMenu = !state.collapseMenu
          break
        case actionType.COLLAPSE_TOGGLE: {
          if (menu.type === 'sub') {
            open = state.isOpen
            trigger = state.isTrigger
            const triggerIndex = trigger.indexOf(menu.id)
            if (triggerIndex > -1) {
              open = open.filter(item => item !== menu.id)
              trigger = trigger.filter(item => item !== menu.id)
            }
            if (triggerIndex === -1) {
              open = [...open, menu.id]
              trigger = [...trigger, menu.id]
            }
          } else {
            open = state.isOpen
            const triggerIndex = state.isTrigger.indexOf(menu.id)
            trigger = triggerIndex === -1 ? [menu.id] : []
            open = triggerIndex === -1 ? [menu.id] : []
          }
          state.isOpen = open
          state.isTrigger = trigger
          break
        }
        case actionType.NAV_COLLAPSE_LEAVE: {
          if (action.menu.type === 'sub') {
            open = state.isOpen
            trigger = state.isTrigger
            const triggerIndex = trigger.indexOf(menu.id)
            if (triggerIndex > -1) {
              open = open.filter(item => item !== menu.id)
              trigger = trigger.filter(item => item !== menu.id)
            }
          }
          state.isOpen = open
          state.isTrigger = trigger
          break
        }
        case actionType.NAV_CONTENT_LEAVE:
          state.isOpen = open
          state.isTrigger = trigger
          break
        case actionType.RESET:
          state.layout = initialState.layout
          state.collapseMenu = initialState.collapseMenu
          break
        default:
          throw new Error()
      }
    },
  },
})

export const { changeConfig } = themeSlice.actions
export default themeSlice.reducer
